import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-badge',
  imports: [NgClass],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.css',
  standalone: true
})
export class BadgeComponent implements OnInit, OnChanges {
  @Input() color!: string;
  @Input() text: string = '';

  protected bgColor?: string;
  protected textColor?: string;
  protected darkBgColor?: string;
  protected darkTextColor?: string;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['color']) {
      const colors = this.getColors(this.color);
      this.bgColor = colors.bg;
      this.textColor = colors.text;
      this.darkBgColor = colors.darkBg;
      this.darkTextColor = colors.darkText;
    }
  }

  ngOnInit() {
    const colors = this.getColors(this.color);
    this.bgColor = colors.bg;
    this.textColor = colors.text;
    this.darkBgColor = colors.darkBg;
    this.darkTextColor = colors.darkText;
  }

  protected getColors(color?: string) {
    switch (color) {
      case 'primary':
        return {
          bg: 'bg-brand-50',
          text: 'text-brand-500',
          darkBg: 'dark:bg-brand-500/15',
          darkText: 'dark:text-brand-400',
        };
      case 'success':
        return {
          bg: 'bg-success-50',
          text: 'text-success-600',
          darkBg: 'dark:bg-success-500/15',
          darkText: 'dark:text-success-500',
        };
      case 'error':
        return {
          bg: 'bg-error-50',
          text: 'text-error-600',
          darkBg: 'dark:bg-error-500/15',
          darkText: 'dark:text-error-500',
        };
      case 'warning':
        return {
          bg: 'bg-warning-50',
          text: 'text-warning-600',
          darkBg: 'dark:bg-warning-500/15',
          darkText: 'dark:text-orange-400',
        };
      case 'info':
        return {
          bg: 'bg-blue-light-50',
          text: 'text-blue-light-500',
          darkBg: 'dark:bg-blue-light-500/15',
          darkText: 'dark:text-blue-light-500',
        };
      case 'light':
        return {
          bg: 'bg-gray-100',
          text: 'text-gray-700',
          darkBg: 'dark:bg-white/5',
          darkText: 'dark:text-white/80',
        };
      case 'dark':
        return {
          bg: 'bg-gray-500',
          text: 'text-white',
          darkBg: 'dark:bg-white/5',
          darkText: 'dark:text-white',
        };
      default:
        return {
          bg: '',
          text: '',
          darkBg: '',
          darkText: '',
        };
    }
  }
}
